var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

require('jquery.dotdotdot');
var FontFaceObserver = require('fontfaceobserver');

require('./RecentNews.less');

module.exports = Backbone.View.extend({
    el: '.RecentNews',

    initialize: function () {
        var fontOpenSans = new FontFaceObserver('Open Sans', {
            weight: 400
        });

        fontOpenSans.load().then(function () {
            this.$('.RecentNews-title').dotdotdot();
        }.bind(this));
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/RecentNews/RecentNews.js
// module id = 30
// module chunks = 0